import { router } from "@inertiajs/react";
import { ApprenticeView } from "../../../components/apprentice/ApprenticeView";
import { ApprenticeViewTabs, ApprenticeViewTabValues } from "../../../components/apprentice/ApprenticeViewTabs";
import { StatusIndicator } from "../../../components/indicator/StatusIndicator";
import { getFullName } from "../../../helpers/stringHelper";
import { useRole } from "../../../hooks/useProps";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Apprentice } from "../../../models/apprentice";
import { Role } from "../../../models/enums/role";
import { apprentices_path } from "../../../routes";

type ApprenticeDetailProps = {
  apprentice: Apprentice;
};

export default function ApprenticeDetail({ apprentice }: ApprenticeDetailProps) {
  const { pathWithYearContext } = useYearContext();
  const role = useRole();
  const onBack = role !== Role.APPRENTICE ? () => router.get(pathWithYearContext(apprentices_path)) : undefined;

  return (
    <ContentShell
      title={`Lernende/r ${getFullName(apprentice)}`}
      pageTitle={getFullName(apprentice)}
      onBack={onBack}
      titleIcon={<StatusIndicator active={apprentice.user.active} />}
    >
      <ApprenticeViewTabs apprenticeId={apprentice.id} activeTab={ApprenticeViewTabValues.VIEW} />
      <ApprenticeView apprentice={apprentice} />
    </ContentShell>
  );
}
